export default __webpack_public_path__ + "static/media/background.011a3963.jpg";